<template>
  <div class="nissan-wechat-login">
    <img
      src="./images/btn-wechat.png"
      class="img-btn-wechat"
      @click="wechatLogin"
    />
  </div>
</template>

<script>
import { param2Obj } from '@/utils/utils.js'
import { thirdLoginHanlder } from '@/utils/mutiple.js'
import { getItem } from '@/utils/storage-main.js'
import { Loading } from 'element-ui'

export default {
  props: ['isCheckAgreement'],
  async created() {
    const { code, appid } = param2Obj(window.location.href)
    if (code) {
      Loading.service({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255)',
        customClass: 'wechat-loading',
      })
      const params = {
        code,
        mode: 'open_wechat_mobile',
        partner_wechat_app_id: appid,
      }
      await thirdLoginHanlder(getItem('business'), params)
    }
  },

  methods: {
    wechatLogin() {
      if (this.isCheckAgreement) {
        const appid = process.env.VUE_APP_NISSAN_APPID
        const redirect_uri = encodeURIComponent(window.location.href)
        const state = this.generateUid()
        const component_appid = process.env.VUE_APP_NISSAN_COMPONENT_APPID
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}&component_appid=${component_appid}#wechat_redirect`
        window.location.replace(url)
      } else {
        this.$message.error({
          message: this.$t('login.register.acceptTermsPop'),
          customClass: 'nissan-error-message',
        })
      }
    },
    generateUid() {
      return Date.now() + '-' + Math.random().toString(36).substr(2, 9)
    },
  },
}
</script>

<style lang="scss">
.wechat-loading {
  .el-icon-loading {
    color: #ccc;
  }
}

.nissan-wechat-login {
  width: 100%;

  .img-btn-wechat {
    width: 100%;
  }
}
</style>
